export const TABS = [
  {
    name: "contacts",
    label: "CONTACT_DIALOG.tab.contacts"
  },
  {
    name: "platform",
    label: "CONTACT_DIALOG.tab.platform"
  },
  {
    name: "netzeBw",
    label: "CONTACT_DIALOG.tab.netzeBw"
  }
];

export const SOCIAL_MEDIA_BUTTONS = [
  {
    name: "twitter",
    path: "/assets/images/social-media/x-twitter-v2.svg",
    url: "https://twitter.com/netzebw?lang=de"
  },
  {
    name: "youtube",
    path: "/assets/images/social-media/youtube-v2.svg",
    url: "https://www.youtube.com/channel/UC1IZ9Ybcn0qAhg2HOIYqWMQ/featured"
  },
  {
    name: "linkedin",
    path: "/assets/images/social-media/linkedin-v2.svg",
    url: "https://www.linkedin.com/company/netze-bw-gmbh/"
  },
  {
    name: "instagram",
    path: "/assets/images/social-media/instagram-v2.svg",
    url: "https://www.instagram.com/netze_bw/?hl=de"
  }
];

export const PLATFORM_FEEDBACK_TOPICS_OPTIONS: Array<any> = [
  {
    value: "improvementIdeas",
    label: "CONTACT_DIALOG.feedbackForm.feedbackTopic.improvement"
  },
  {
    value: "errors",
    label: "CONTACT_DIALOG.feedbackForm.feedbackTopic.error"
  },
  {
    value: "other",
    label: "CONTACT_DIALOG.feedbackForm.feedbackTopic.miscellaneous"
  }
];

export const NETZE_BW_FEEDBACK_TOPICS_OPTIONS: Array<any> = [
  {
    value: "request",
    label: "CONTACT_DIALOG.feedbackForm.feedbackTopic.request"
  },
  {
    value: "complaint",
    label: "CONTACT_DIALOG.feedbackForm.feedbackTopic.complaint"
  },
  {
    value: "feedback",
    label: "CONTACT_DIALOG.feedbackForm.feedbackTopic.feedback"
  },
  {
    value: "other",
    label: "CONTACT_DIALOG.feedbackForm.feedbackTopic.miscellaneous"
  }
];

export const OCCURED_ERRORS_OPTIONS: Array<any> = [
  {
    value: "cockpit",
    label: "CONTACT_DIALOG.feedbackForm.feedbackErrorType.cockpit"
  },
  {
    value: "maptopics",
    label: "CONTACT_DIALOG.feedbackForm.feedbackErrorType.maptopics"
  },
  {
    value: "selection",
    label: "CONTACT_DIALOG.feedbackForm.feedbackErrorType.selection"
  },
  {
    value: "miscellaneous",
    label: "CONTACT_DIALOG.feedbackForm.feedbackErrorType.miscellaneous"
  },
  {
    value: "search",
    label: "CONTACT_DIALOG.feedbackForm.feedbackErrorType.search"
  }
];
